(function () {
  'use strict';
  if (window.optileanCartGroupsInitialized) return;
  window.optileanCartGroupsInitialized = true;
  // Native cart forms serialize updates[] by DOM order. Preserve Shopify's
  // original line order while the visible rows are grouped by shadow board.
  document.addEventListener('formdata', function (event) {
    var inputs = Array.from(event.target.elements || []).filter(function (input) {
      return input.name === 'updates[]' && !input.disabled && input.closest('[data-cart-group-item]');
    });
    if (!inputs.length) return;
    inputs.sort(function (a, b) { return Number(a.dataset.index) - Number(b.dataset.index); });
    event.formData.delete('updates[]');
    inputs.forEach(function (input) { event.formData.append('updates[]', input.value); });
  }, true);
  function refresh() {
    if (!window.optileanCartGrouping) return;
    document.querySelectorAll('cart-items tbody').forEach(function (body) {
      var items = Array.from(body.querySelectorAll('.cart-item[data-cart-group-item]')).map(function (row) {
        var item = JSON.parse(row.dataset.cartGroupItem); item.row = row; return item;
      });
      var ordering = window.optileanCartOrder;
      if (ordering) items = ordering.apply(items, body);
      var groups = window.optileanCartGrouping.groups(items, {preserveOrder: ordering && ordering.manual()});
      var signature = JSON.stringify(groups.map(function (group) { return [group.key, group.name, group.items.map(function (item) { return item.key; })]; }));
      if (body.dataset.groupSignature === signature) return;
      body.dataset.groupSignature = signature;
      body.querySelectorAll('[data-cart-group-heading]').forEach(function (heading) { heading.remove(); });
      var fragment = document.createDocumentFragment();
      groups.forEach(function (group, index) {
        if (groups.some(function (entry) { return !entry.other; })) {
          var row = document.createElement('tr'); row.className = 'cart-group-heading'; row.dataset.cartGroupHeading = '';
          var cell = document.createElement('td'); cell.colSpan = 4;
          var title = document.createElement('h3');
          title.textContent = group.other ? body.dataset.otherLabel : body.dataset.boardLabel + ' ' + (group.name || String(index + 1));
          cell.append(title); row.append(cell); fragment.append(row);
        }
        group.items.forEach(function (item) { fragment.append(item.row); });
      });
      body.append(fragment);
      if (ordering) ordering.decorate(body);
    });
  }
  document.addEventListener('optilean:cart-order', refresh);
  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; refresh(); });
  });
  refresh();
  observer.observe(document.body, { childList: true, subtree: true });
})();
